/* global DetectUserAgent */
import { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import { appRoutes } from "routes";
import { getImageUrl } from "utils/imageHandlerUtils";
import { handlerSelectItemEvent } from "tracking/google/analytics";
import StarringYouClipPresenter from "presenters/StarringYouClipPresenter";
import { useTemplateGroupTracking, useCategory, useHomePage } from "hooks";

import { Root, PlayerWrapper, StyledReactPlayer, Overlay, ImageName, Poster, Duration, ClipSkeleton } from "./styles";

const StarringYouClip = ({
  showVideo = true,
  item,
  loading = false,
  playing = false,
  isStatic = false,
  isActive = false,
  onClick,
  hasModulePosition,
}) => {
  const clipRef = useRef(null);
  const videoRef = useRef(null);
  const { trackClick } = useTemplateGroupTracking(item);
  const { category } = useCategory();
  const { homePage } = useHomePage();
  const isFbInAppBrowser = DetectUserAgent.isFBInAppBrowser();

  useEffect(() => {
    if (videoRef.current && isActive && isFbInAppBrowser)
      videoRef.current.poster = getImageUrl(StarringYouClipPresenter.thumb(item), {});
  }, [item, isActive, isFbInAppBrowser]);

  const handleClick = () => {
    trackClick();

    if (onClick) onClick(item);

    if (!hasModulePosition) handlerSelectItemEvent(item, category, homePage);
  };

  if (loading)
    return <ClipSkeleton data-testid="starringyouclip-loading" variant="rect" animation="wave" ratio="16/9" />;

  return (
    <Root onClick={handleClick} to={appRoutes.templateGroupPath(StarringYouClipPresenter.id(item))} component={NavLink}>
      <div role="presentation" ref={clipRef} style={{ position: "relative" }}>
        <PlayerWrapper>
          {showVideo === true && (
            <StyledReactPlayer
              ref={videoRef}
              height="100%"
              width="100%"
              playing={playing}
              loop
              muted
              playsInline
              src={StarringYouClipPresenter.animatedThumb(item)}
            />
          )}
          {!isActive && (
            <Poster
              alt={StarringYouClipPresenter.name(item)}
              src={StarringYouClipPresenter.thumb(item)}
              width={600}
              widthMobile={226}
            />
          )}
        </PlayerWrapper>
        <Overlay />
        {item.titleImage && (
          <ImageName
            src={item.titleImage}
            alt={`${StarringYouClipPresenter.name(item)} Logo`}
            width={442}
            widthMobile={170}
          />
        )}
        <Duration isStatic={isStatic}>{StarringYouClipPresenter.duration(item)}</Duration>
      </div>
    </Root>
  );
};

StarringYouClip.propTypes = {
  showVideo: PropTypes.bool,
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    titleImage: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
    attributes: PropTypes.shape({}),
  }),
  playing: PropTypes.bool,
  loading: PropTypes.bool,
  isStatic: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  hasModulePosition: PropTypes.bool,
};

export default StarringYouClip;
